const processConversationData = (data, conversationId) => {
  if (!data || !data.messages || data.messages.length === 0) {
    return {
      messages: [],
      productMap: /* @__PURE__ */ new Map(),
      surveyMap: /* @__PURE__ */ new Map(),
      followUpQuestions: [],
      previewSearchQueries: [],
      previewQueryProducts: []
    };
  }
  const lastAssistantMessage = [...data.messages].reverse().find((m) => m.role === "assistant");
  const previewSearchQueries = Array.isArray(lastAssistantMessage == null ? void 0 : lastAssistantMessage.previewSearchQueries) ? lastAssistantMessage.previewSearchQueries : [];
  const previewQueryProducts = Array.isArray(lastAssistantMessage == null ? void 0 : lastAssistantMessage.previewQueryProducts) ? lastAssistantMessage.previewQueryProducts : [];
  const productMap = /* @__PURE__ */ new Map();
  if (data.products && Array.isArray(data.products)) {
    data.products.forEach((product) => {
      productMap.set(product.stacklineSku, product);
    });
  }
  const surveyMap = /* @__PURE__ */ new Map();
  if (data.surveys && Array.isArray(data.surveys)) {
    data.surveys.forEach((survey) => {
      surveyMap.set(survey.campaignId, survey);
    });
  }
  data.messages.forEach((msg) => {
    if (msg.surveys && Array.isArray(msg.surveys)) {
      msg.surveys.forEach((survey) => {
        if (!surveyMap.has(survey.campaignId)) {
          surveyMap.set(survey.campaignId, survey);
        }
      });
    }
  });
  const messages = data.messages.filter((msg) => msg.role === "user" || msg.role === "assistant").map((msg) => {
    const parts = msg.uiMessageParts && Array.isArray(msg.uiMessageParts) && msg.uiMessageParts.length > 0 ? msg.uiMessageParts : [{ type: "text", text: typeof msg.content === "string" ? msg.content : "" }];
    const uiMsg = {
      id: msg.messageIndex != null ? `msg-${msg.messageIndex}` : `msg-${Date.now()}`,
      role: msg.role,
      parts
    };
    if (msg.messageIndex != null) uiMsg.messageIndex = msg.messageIndex;
    if (msg.feedback) uiMsg.feedback = msg.feedback;
    if (msg.role === "assistant") {
      if (msg.storeLocator) uiMsg.storeLocator = msg.storeLocator;
      if (msg.loginRequired) uiMsg.loginRequired = msg.loginRequired;
      if (msg.orders && msg.orders.length > 0) uiMsg.orders = msg.orders;
      if (msg.followUpQueries) uiMsg.followUpQueries = msg.followUpQueries;
      if (msg.devInfo) uiMsg.devInfo = msg.devInfo;
      if (msg.previewSearchQueries) uiMsg.previewSearchQueries = msg.previewSearchQueries;
      if (msg.previewQueryProducts) uiMsg.previewQueryProducts = msg.previewQueryProducts;
    }
    if (msg.role === "user" && msg.imageUrl) {
      uiMsg.imageUrl = msg.imageUrl;
      uiMsg.imageMimeType = msg.imageMimeType;
    }
    return uiMsg;
  }).filter((msg) => {
    if (msg.role === "user") return true;
    return msg.parts.length > 0;
  });
  return {
    messages,
    productMap,
    surveyMap,
    followUpQuestions: data.followUpQuestions || [],
    previewSearchQueries,
    previewQueryProducts
  };
};
export {
  processConversationData
};
//# sourceMappingURL=conversationProcessor.js.map
